module.exports = __webpack_public_path__ + "img/benefits-slider-1.3ca8fe4b.png";